import { adjustLightness } from './colorUtils';

type AppTokens = {
	palette: {
		primary: string;
		secondary: string;
		tertiary: string;
		white: string;
		error: string;
		warning: string;
		readableGray: string;
		darkShade: string;
		lightShade: string;
		lightBorderColor: string;
		darkGray: string;
	};
	derived: {
		primaryDark: string;
		primaryLight: string;
		primaryLightest: string;
		secondaryDark: string;
		secondaryLight: string;
		secondaryLightest: string;
		errorDark: string;
		disabledBackground: string;
		disabledBackgroundHover: string;
		disabledText: string;
		darkBlue: string;
		black: string;
	};
	shape: {
		rounded: string;
	};
	breakpoints: {
		phone: string;
		desktop: string;
	};
	animation: {
		pulseDurationMs: number;
		pulseDurationCss: string;
	};
	stripe: {
		fontFamily: string;
		fontCssSrc: string;
		fontWeight: number;
	};
};

const palette = {
	primary: '#243d32',
	secondary: '#b4be9c',
	tertiary: '#b6d3e2',
	white: '#ffffff',
	error: '#d32f2f',
	warning: '#fbbc05',
	readableGray: '#848a87',
	darkShade: '#494b4a',
	lightShade: '#eaf1f4',
	lightBorderColor: '#e1e1e1',
	darkGray: 'rgb(196, 196, 196)',
} as const;

export const appTokens: AppTokens = {
	palette,
	derived: {
		primaryDark: adjustLightness( palette.primary, -10 ),
		primaryLight: adjustLightness( palette.primary, 15 ),
		primaryLightest: adjustLightness( palette.primary, 70 ),
		secondaryDark: adjustLightness( palette.secondary, -10 ),
		secondaryLight: adjustLightness( palette.secondary, 15 ),
		secondaryLightest: adjustLightness( palette.secondary, 30 ),
		errorDark: '#b12626',
		disabledBackground: '#848a87',
		disabledBackgroundHover: '#717774',
		disabledText: '#eaf1f4',
		darkBlue: '#b4be9c',
		black: '#243d32',
	},
	shape: {
		rounded: '0.4rem',
	},
	breakpoints: {
		phone: '768px',
		desktop: '960px',
	},
	animation: {
		pulseDurationMs: 3000,
		pulseDurationCss: '3000ms',
	},
	stripe: {
		fontFamily: 'Inter',
		fontCssSrc:
			'https://fonts.googleapis.com/css2?family=Inter:wght@300&display=swap',
		fontWeight: 300,
	},
};
